export default function HandymanServices() {
  const services = [
    {
      icon: 'ri-door-line',
      title: 'Door & Window Repairs',
      description: 'Fix squeaky doors, replace locks, repair window screens, and adjust door frames for proper operation.'
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Painting & Drywall',
      description: 'Interior and exterior painting, drywall repair, patching holes, and texture matching services.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Light Fixture Installation',
      description: 'Install ceiling fans, light fixtures, replace switches, and handle basic electrical repairs.'
    },
    {
      icon: 'ri-hammer-line',
      title: 'Furniture Assembly',
      description: 'Professional assembly of furniture, shelving units, and home organization systems.'
    },
    {
      icon: 'ri-drop-line',
      title: 'Plumbing Repairs',
      description: 'Fix leaky faucets, unclog drains, replace fixtures, and handle minor plumbing issues.'
    },
    {
      icon: 'ri-tv-line',
      title: 'TV Mounting & Setup',
      description: 'Secure TV mounting, cable management, and home entertainment system installation.'
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Comprehensive Handyman Services in El Paso
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From small repairs to home improvements, our network of handymen provides reliable services for all your home maintenance needs.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-emerald-50 to-white p-8 rounded-xl border border-emerald-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-emerald-600 text-white rounded-lg mb-6">
                <i className={`${service.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
